import { render, staticRenderFns } from "./CompanyToCoach.vue?vue&type=template&id=cc60b46e&scoped=true"
import script from "./CompanyToCoach.vue?vue&type=script&lang=js"
export * from "./CompanyToCoach.vue?vue&type=script&lang=js"
import style0 from "./CompanyToCoach.vue?vue&type=style&index=0&id=cc60b46e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc60b46e",
  null
  
)

export default component.exports